package es.subastia.ui.mapper

import es.subastia.domain.model.AuctionAuthorityDomainModel
import es.subastia.domain.model.AuctionDatesDomainModel
import es.subastia.domain.model.AuctionDomainModel
import es.subastia.domain.model.AuctionProcedureType
import es.subastia.domain.model.AuctionTypeDomainModel
import es.subastia.domain.model.LotDomainModel
import es.subastia.domain.model.ProvinceDomainModel
import es.subastia.ui.model.AuctionAuthorityUiModel
import es.subastia.ui.model.AuctionDatesUiModel
import es.subastia.ui.model.AuctionTypeUiModel
import es.subastia.ui.model.AuctionUiModel
import es.subastia.ui.model.LotUiModel
import es.subastia.ui.model.ProvinceUiModel

fun AuctionDomainModel.toUi(): AuctionUiModel {
    return AuctionUiModel(
        auctionId = auctionId,
        title = title,
        description = description,
        currentPrice = currentPrice,
        basePrice = basePrice,
        imageUrl = lots.firstOrNull()?.imageUrl,
        dates = dates.toUi(),
        authority = authority?.toUi(),
        location = location,
        category = category?.text,
        type = procedureType?.label,
        procedureType = procedureType ?: AuctionProcedureType.UNKNOWN,
        offersCount = offersCount,
        accountExpediente = accountExpediente,
        aiSummary = aiSummary,
        appraisalValue = appraisalValue,
        auctionValue = auctionValue,
        address = address,
        code = code,
        email = email,
        fax = fax,
        model = model,
        phone = phone,
        bidStep = bidStep,
        boeAnnouncement = boeAnnouncement,
        boeId = boeAnnouncement ?: boeId,
        catastralRef = catastralRef,
        city = city,
        claimedAmount = claimedAmount,
        depositAmount = depositAmount,
        hasLots = hasLots,
        isGoodOpportunity = isGoodOpportunity,
        lotId = lotId,
        minBid = minBid,
        portalUrl = portalUrl,
        province = province?.nm,
        status = status,
        updatedAt = updatedAt,
        lots = lots.map { it.toUi() }
    )
}

fun LotDomainModel.toUi(): LotUiModel {
    return LotUiModel(
        assetId = assetId,
        catastralRef = catastralRef,
        description = description,
        address = address,
        city = city,
        province = province,
        postcode = postcode,
        visitable = visitable,
        charges = charges,
        registryData = registryData,
        possessionStatus = possessionStatus,
        additionalInfo = additionalInfo,
        appraisalValue = appraisalValue,
        auctionValue = auctionValue,
        depositAmount = depositAmount,
        bidStep = bidStep,
        minBid = minBid,
        imageUrl = imageUrl,
        mapImageUrl = mapImageUrl,
        latitude = latitude,
        longitude = longitude
    )
}

fun AuctionDatesDomainModel.toUi(): AuctionDatesUiModel {
    return AuctionDatesUiModel(
        startDate = startDate,
        endDate = endDate
    )
}

fun AuctionAuthorityDomainModel.toUi(): AuctionAuthorityUiModel {
    return AuctionAuthorityUiModel(
        name = name,
        email = email,
        phone = phone
    )
}

fun AuctionTypeDomainModel.toUi(): AuctionTypeUiModel {
    return when (this) {
        AuctionTypeDomainModel.Inmuebles -> AuctionTypeUiModel.Inmuebles
        AuctionTypeDomainModel.Vehiculos -> AuctionTypeUiModel.Vehiculos
        AuctionTypeDomainModel.Otros -> AuctionTypeUiModel.Otros
    }
}

fun AuctionTypeUiModel.toDomain(): AuctionTypeDomainModel {
    return when (this) {
        AuctionTypeUiModel.Inmuebles -> AuctionTypeDomainModel.Inmuebles
        AuctionTypeUiModel.Vehiculos -> AuctionTypeDomainModel.Vehiculos
        AuctionTypeUiModel.Otros -> AuctionTypeDomainModel.Otros
    }
}

fun ProvinceDomainModel.toUi(): ProvinceUiModel {
    return ProvinceUiModel.valueOf(this.name)
}

fun ProvinceUiModel.toDomain(): ProvinceDomainModel {
    return ProvinceDomainModel.valueOf(this.name)
}
